import { LuPlus } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../../view_stores/useSideMenuStore";
import { PrimaryButton } from "../../common_components/Buttons";

const ICON_SIZE = 24;

export default function SideMenuStartNewProjectBtn(): JSX.Element {
  const { close: closeSideMenu } = useSideMenuActions();
  const sideMenuBehavior = useSideMenuBehavior();
  const navigate = useNavigate();

  function handleClick(): void {
    if (sideMenuBehavior === SideMenuBehavior.AUTO) {
      window.dispatchEvent(new Event("darvin-block-reopen-menu"));
      closeSideMenu();
    }

    navigate("/", {
      state: { focusTextField: true },
      replace: true,
    });
  }

  return (
    <PrimaryButton
      onClick={handleClick}
      label="Start new project"
      icon={<LuPlus size={ICON_SIZE} />}
      align="left"
    />
  );
}
